import axios from 'axios';

// Set the base URL to point to the news API endpoint
export const BASE_URL = `${process.env.REACT_APP_API_URL}/api`;


export const fetchNews = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(`${BASE_URL}/news/all?page=${page}&limit=${limit}`);
    return response.data.map(item => ({ ...item, type: 'news' }));
  } catch (error) {
    console.error('Error fetching news:', error);
    throw error;
  }
};

// Events API functions
export const fetchEvents = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(`${BASE_URL}/events/all?page=${page}&limit=${limit}`);
    return response.data.map(item => ({ ...item, type: 'event' }));
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};

export const createNews = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL}/news/create`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Needed for file uploads
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating news:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Function to update news
export const updateNews = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL}/news/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Needed for file uploads
      },
    });
    console.log('Response from update:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error updating news:', error.response || error.message);
    throw error;
  }
};

// Function to delete news
export const deleteNews = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/news/${id}`); // Adjusted endpoint to not include extra 'news'
    return response.data;
  } catch (error) {
    console.error('Error deleting news:', error);
    throw error;
  }
};

// Optionally, create a function for fetching a single news article by ID
export const getNewsById = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}/${id}`); // Fetch by ID
    return response.data;
  } catch (error) {
    console.error('Error fetching news by ID:', error);
    throw error;
  }
};